import React, {
    useContext,
    useState,
    useEffect,
    useCallback
} from 'react';
import {
    Switch, Route, Redirect, useHistory, useLocation
} from 'react-router-dom';
import _ from 'lodash';
// Imported First to allow Jutro styles to be overridden
import './App.scss';
import { setComponentMapOverrides } from '@jutro/uiconfig';
import {
    Main,
    Icon,
    Chevron,
    ModalNextProvider
} from '@jutro/components';
import { Table, TableColumn } from '@jutro/datatable';
import { TranslatorContext } from '@jutro/locale';
import { NavRoutes } from '@jutro/router';
import { error } from '@jutro/logger';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import {
    DynamicRoute, GrantedAuthorities, withAuthContextProvider, useAuthentication
} from 'gw-digital-auth-react';
import vmTranslator, { messages as commonMessages } from 'gw-platform-translations';
import { AccurateBreakpointPropagation } from 'gw-jutro-adapters-react';
import { EnrollmentService } from 'gw-capability-policyenrollment';
import { ViewModelServiceFactory } from 'gw-portals-viewmodel-js';
import { PolicyDetails } from 'gw-capability-policy-react';
import { AvailabilityService } from 'gw-capability-policycommon';
import { EndorsementService } from 'gw-capability-policychange';
// #region  TDIC doesn't have PA and HO, hence removed
// import { PAPolicyChangeWizard } from 'gw-capability-policychange-pa-react';
// import { HOPolicyChangeWizard } from 'gw-capability-policychange-ho-react';
// #endregion
import { LoginCapabilityComponentMap, LoginCapabilityComponents } from 'gw-portals-login-react';
import { personalizedOfferComponentMap, personalizedOfferComponents } from 'gw-capability-personalizedoffers-react';
import { VehicleInfoLookupComponentMap, VehicleInfoLookupComponents } from 'gw-capability-vehicleinfo-react';
import { policyJobComponentMap, policyJobComponents } from 'gw-capability-policyjob-react';
import {
    BillingSummaryPage,
    MakePaymentPage,
    billingComponentMap,
    billingAdditionalComponents
} from 'gw-capability-billing-react';
import { AdditionalEnrollment, SignUpEnrollment } from 'gw-capability-enrollment-react';
import { UsersProfile } from 'gw-capability-profileinfo-react';
import { WizardPageTemplateWithTitle } from 'gw-portals-wizard-react';
import { ProducerInfoService, UsersProfileDetailsService } from 'gw-capability-profileinfo';

import { DependencyProvider } from 'gw-portals-dependency-react';
import { AccountBillingDetailsService, BillingService } from 'gw-capability-billing';
import { PolicyService } from 'gw-capability-policy';
import { ClaimDocumentService } from 'gw-capability-claimdocument';

import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import {
    platformComponentMap,
    platformComponents,
    ImageComponent,
} from 'gw-components-platform-react';
import { ErrorBoundary } from 'gw-portals-error-react';
import BaseFNOLWizard, { ClaimsConfirmationPage } from 'gw-capability-fnol-common-react';
import { ContactAgentPage } from 'gw-pages-platform-react';
import {
    TnCComponent, CMSComponent, ApplicationPropertyWithContextProvider, ErrorPage, AppError
} from 'tdic-components-platform-react';
import FNOLPAWizard from 'gw-capability-fnol-pa-react';
import FNOLWCWizard from 'gw-capability-fnol-wc-react';
import FNOLCAWizard from 'gw-capability-fnol-ca-react';
import FNOLHOWizard from 'gw-capability-fnol-ho-react';
import FNOLCPWizard from 'gw-capability-fnol-cp-react';
import FNOLBOPWizard from 'gw-capability-fnol-bop-react';
import FNOLGeneralWizard from 'gw-capability-fnol-gl-react';

import {
    ClaimList, ClaimDetails, CreateNote, PolicyLevelCoverages
} from 'gw-capability-claim-react';
import { ClaimService } from 'gw-capability-claim';
import { FNOLService } from 'gw-capability-fnol';
import FaqPage from 'gw-capability-faq-react';
import { PolicyDocumentError } from 'gw-capability-document-react';
import { filterCapabilityRoutes } from 'gw-portals-config-js';

// #region TDIC packages and pages
import FNOLPLWizard from 'tdic-capability-fnol-pl-react';
import FNOLLRPWizard from 'tdic-capability-fnol-lrp-react';
import FNOLWC7Wizard from 'tdic-capability-fnol-wc7-react';
import FNOLCLWizard from 'tdic-capability-fnol-cl-react';
import Quote from 'tdic-capability-quote-react';
import { PLRenewalSurvey, PLRenewalSurveyQuestionnaire } from 'tdic-capability-survey-react';
import { PLPolicyChangeWizard } from 'tdic-capability-policychange-pl-react';
import { CLPolicyChangeWizard } from 'tdic-capability-policychange-cl-react';
import { BOPPolicyChangeWizard } from 'tdic-capability-policychange-bop-react';
import { LRPPolicyChangeWizard } from 'tdic-capability-policychange-lrp-react';
import { WC7PolicyChangeWizard } from 'tdic-capability-policychange-wc7-react';
import RiskManagement from 'tdic-capability-risk-management-react';
import ServiceRequest from 'tdic-capability-service-request-react';
import { AddressLookupComponentMap, AddressLookupComponents } from 'tdic-capability-address-react';
import ManageUser from 'tdic-capability-manageuser-react';
import FooterComponent from '../components/Footer/FooterComponent';
import TermsAndConditions from '../tdicpages/TermsAndConditions/TermsAndConditions';
import UserEmailConfirmation from '../tdicpages/UserEmailConfirmation/UserEmailConfirmation';
import AccessDenied from '../tdicpages/AccessDenied/AccessDenied';
import AccessDeniedLandingPage from '../tdicpages/AccessDenied/AccessDeniedLandingPage';
import DeclarationPage from '../tdicpages/DeclarationPage/DeclarationPage';
import LandingPage from '../tdicpages/LandingPage/LandingPage';
// #endregion TDIC packages and pages

import PageHeaderComponent from '../components/PageHeaderComponent/PageHeaderComponent';
import { routes } from './App.routes.metadata.json5';
import ResetPasswordPage from '../pages/ResetPasswordPage/ResetPasswordPage';
import EntryPage from '../pages/EntryPage/EntryPage';
// TDIC: Removed OOTB landing page
// import LandingPage from '../pages/LandingPage/LandingPage';
import messages from './App.messages';

const { capabilitiesConfig } = appConfig;

const componentMap = {
    landingpage: LandingPage,
    useremailconfirmation: UserEmailConfirmation,
    policydocumenterror: PolicyDocumentError,
    fnolwcwizard: FNOLWCWizard,
    basefnolwizard: BaseFNOLWizard,
    claimsconfirmationpage: ClaimsConfirmationPage,
    contactagent: ContactAgentPage,
    errorpage: ErrorPage,
    apperror: AppError,
    fnolpawizard: FNOLPAWizard,
    fnolhowizard: FNOLHOWizard,
    additionalenrollmentpage: AdditionalEnrollment,
    claimlist: ClaimList,
    claimdetails: ClaimDetails,
    manageusercomponent: ManageUser,
    policydetailspage: PolicyDetails,
    // #region TDIC doesn't have PA and HO, hence removed
    // papolicychangewizard: PAPolicyChangeWizard,
    // hopolicychangewizard: HOPolicyChangeWizard,
    // #endregion
    plpolicychangewizard: PLPolicyChangeWizard,
    boppolicychangewizard: BOPPolicyChangeWizard,
    clpolicychangewizard: CLPolicyChangeWizard,
    lrppolicychangewizard: LRPPolicyChangeWizard,
    wc7policychangewizard: WC7PolicyChangeWizard,
    createnote: CreateNote,
    billingsummarypage: BillingSummaryPage,
    makepaymentpage: MakePaymentPage,
    usersprofile: UsersProfile,
    policylevelcoverages: PolicyLevelCoverages,
    faqpage: FaqPage,
    fnolcawizard: FNOLCAWizard,
    fnolcpwizard: FNOLCPWizard,
    fnolbopwizard: FNOLBOPWizard,
    fnolgeneralwizard: FNOLGeneralWizard,
    fnolplwizard: FNOLPLWizard,
    fnollrpwizard: FNOLLRPWizard,
    riskmanagement: RiskManagement,
    fnolwc7wizard: FNOLWC7Wizard,
    servicerequest: ServiceRequest,
    fnolclwizard: FNOLCLWizard,
    termsandconditions: TermsAndConditions,
    quote: Quote,
    plrenewalsurvey: PLRenewalSurvey,
    signupenrollment: SignUpEnrollment,
    declarationpage: DeclarationPage
};

const shouldRouteToSignUp = (authorities) => {
    // TDIC: ADA_NUMBER and AUTHORISED_USER_EXT authority check
    const accountAuthorities = authorities.filter((authority) => authority.authorityType === _.get(appConfig, 'self-enrollment.tdicADAType', '')
    || (authority.authorityType === 'AUTHORISED_USER_EXT'));
    // if user doesn't have ACCOUNT authorities it is supposed to be enrolled
    if (accountAuthorities.length === 0) {
        return <Redirect to="/signup-enrollment" />;
    }
    return null;
};

setComponentMapOverrides(
    {
        ...AddressLookupComponentMap,
        ...platformComponentMap,
        ...personalizedOfferComponentMap,
        ...VehicleInfoLookupComponentMap,
        ...LoginCapabilityComponentMap,
        ...policyJobComponentMap,
        ...billingComponentMap,
        Icon: { component: 'Icon' },
        Table: { component: 'Table' },
        TableColumn: { component: 'TableColumn' },
        table: { component: 'table' },
        tableColumn: { component: 'tableColumn' },
        Chevron: { component: 'Chevron' },
        WizardPageTemplateWithTitle: { component: 'WizardPageTemplateWithTitle' },
        // replace the native IMG component with a proxied version
        img: { component: 'img' },
        tnccomponent: { component: 'tnccomponent' },
        cmscomponent: { component: 'cmscomponent' },
        declarationpage: { component: 'declarationpage' }
    },
    {
        ...AddressLookupComponents,
        ...platformComponents,
        ...personalizedOfferComponents,
        ...VehicleInfoLookupComponents,
        ...LoginCapabilityComponents,
        ...policyJobComponents,
        ...billingAdditionalComponents,
        Icon,
        Table,
        TableColumn,
        table: Table,
        tableColumn: TableColumn,
        Chevron,
        WizardPageTemplateWithTitle,
        img: ImageComponent,
        tnccomponent: TnCComponent,
        cmscomponent: CMSComponent,
        declarationpage: DeclarationPage
    }
);

// (Router) Title is required and used for (Browser) title
// in a format of "${title} - ${appName}". In order to show
// the application name only, it needs to be an empty value.
const appRoutes = filterCapabilityRoutes(capabilitiesConfig, routes);

const usePrevious = (value) => {
    const ref = React.useRef();
    React.useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};

const useLocationChange = (action) => {
    const location = useLocation();
    const prevLocation = usePrevious(location);
    React.useEffect(() => {
        // Create a variable to store timeouts if this
        // component becomes unmounted.
        const runningTimeouts = [];
        action(location, prevLocation, runningTimeouts);
        // return an expression to cancel running timeouts
        return () => {
            runningTimeouts.forEach((t) => clearTimeout(t));
        };
    }, [location]); // Only re-run if the location changes
};

function App() {
    const auth = useAuthentication();
    const history = useHistory();
    const translator = useContext(TranslatorContext);
    const [viewModelService, setViewModelService] = useState(undefined);
    const [navRoutes, updateRoutes] = useState(appRoutes);
    const [isPermissionChecked, updatePermissionChecked] = useState(false);
    const [isAnesthesiaSurveyAvailable, setIsAnesthesiaSurveyAvailable] = useState(false);

    const dynamicComponentMap = {
        ...componentMap,
        plrenewalsurvey: isAnesthesiaSurveyAvailable ? PLRenewalSurveyQuestionnaire
            : PLRenewalSurvey
    };

    // Update appRoutes to mark all routes as available.
    useEffect(() => {
        updateRoutes(navRoutes.map((rt) => {
            const availVal = (rt.available !== undefined) ? rt.available : true;
            return {
                ...rt,
                available: availVal
            };
        }));
    }, [navRoutes.length]); // Only re-run this if the number of routes changes

    useEffect(() => {
        const translatorFn = vmTranslator(translator);
        import(
            /* webpackChunkName: "product-metadata" */
            // eslint-disable-next-line import/no-unresolved
            'product-metadata'
        ).then((productMetadata) => {
            const { default: result } = productMetadata;
            setViewModelService(
                ViewModelServiceFactory.getViewModelService(result, translatorFn)
            );
        });
    }, [translator]);

    const filterNotAvailableRoutes = (rts) => {
        return _.filter(rts, 'available');
    };

    const routesWithoutTitle = useCallback(() => {
        return filterNotAvailableRoutes(navRoutes.map((route) => {
            return {
                ...route,
                title: ''
            };
        }));
    }, [navRoutes]);

    // TDIC: checkUserManagementAccess method using for show and hide menu based on xCenter data
    const checkUserManagementAccess = useCallback(() => {
        if (!_.isEmpty(auth.authHeader) && !isPermissionChecked) {
            updatePermissionChecked(true);
            UsersProfileDetailsService.getTDICUserAccessList(auth.authHeader)
                .then((response) => {
                    const defaultRoutes = _.cloneDeep(navRoutes);
                    const pathsToMakeUnavailable = [];
                    const pathsToMakeAvailable = [];

                    if (_.isEmpty(response) || !_.get(_.find(response, { menuOption: 'RiskManagement' }), 'available', false)) {
                        pathsToMakeUnavailable.push('/risk-management');
                    } else {
                        pathsToMakeAvailable.push('/risk-management');
                    }

                    const plPolicyChangeSurveyAvailable = _.get(_.find(response, { menuOption: 'PLPolicyChangeSurvey' }), 'available', false);
                    const policiesForAnestheticModalityAvailable = _.get(_.find(response, { menuOption: 'PoliciesForAnestheticModalityQuestionnaire' }), 'available', false);
                    setIsAnesthesiaSurveyAvailable(policiesForAnestheticModalityAvailable);
                    if (_.isEmpty(response)
                        || (!plPolicyChangeSurveyAvailable
                    && !policiesForAnestheticModalityAvailable)) {
                        pathsToMakeUnavailable.push('/pl-policy-questionnaire');
                    } else {
                        pathsToMakeAvailable.push('/pl-policy-questionnaire');
                    }

                    const effUserAuthUserPaths = [
                        '/claims',
                        '/risk-management',
                        '/user-management',
                        '/service-request',
                        '/request-a-quote',
                        '/pl-policy-questionnaire'
                    ];
                    if (_.get(_.find(response, { menuOption: 'EffectiveUserIsAuthorizedUser' }), 'available', false)) {
                        pathsToMakeUnavailable.push(...effUserAuthUserPaths);
                    } else {
                        pathsToMakeAvailable.push(...effUserAuthUserPaths);
                    }

                    // Update the available property of each route.
                    updateRoutes(defaultRoutes.map((rt) => {
                        let availVal = rt.available;
                        if (pathsToMakeUnavailable.includes(rt.path)) {
                            availVal = false;
                        } else if (pathsToMakeAvailable.includes(rt.path)) {
                            availVal = true;
                        }
                        return {
                            ...rt,
                            available: availVal
                        };
                    }));
                }).catch((err) => {
                    error(`App.js : getTDICUserAccessList - Unable to get TDIC User Access List ${JSON.stringify(err)}`);
                    return history.push('/app-error');
                });
        }
    }, [auth.authHeader, history, isPermissionChecked, navRoutes]);

    useEffect(() => {
        checkUserManagementAccess();
    }, [checkUserManagementAccess]);

    const recheckPermissions = (runningTimeouts, timeoutVal) => {
        // if timeoutVal > 16, we're done checking so exit
        if (timeoutVal > 16) {
            return;
        }
        // If the '/risk-management' route isn't available,
        // then we need to re-run the permission check.
        const recheckPerms = _.find(navRoutes, { path: '/risk-management', available: false }) !== null;
        if (recheckPerms) {
            // Double the next permission check timeout
            const nextTimeoutVal = (timeoutVal > 0) ? timeoutVal * 2 : 1;
            // Just updating this forces checkUserManagementAccess to re-run.
            updatePermissionChecked(false);
            // Schedule the check to happen in nextTimeoutVal seconds.
            runningTimeouts.push(
                setTimeout(() => {
                    recheckPermissions(runningTimeouts, nextTimeoutVal);
                }, nextTimeoutVal * 1000)
            );
        }
    };

    useLocationChange((location, prevLocation, runningTimeouts) => {
        const routesToForceUpdatePermissions = [
            '/signup-enrollment',
            '/additional-enrollment'
        ];
        const recheckPerms = isPermissionChecked
            && routesToForceUpdatePermissions.includes(prevLocation.pathname);
        if (recheckPerms) {
            // If we came from the enrollment screen and the risk
            // management tab is not available, we need to schedule
            // checks periodically to see if the tab is available.
            // This will keep checking a few times until a limit
            // is reached.
            recheckPermissions(runningTimeouts, 0);
        }
    });

    const handleError = useCallback(() => {
        return ModalNextProvider.showAlert({
            title: messages.error,
            message: messages.errorMessage,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    }, []);

    return (
        <AccurateBreakpointPropagation>
            <DependencyProvider
                value={{
                    AccountBillingDetailsService: AccountBillingDetailsService,
                    PolicyService: PolicyService,
                    EndorsementService: EndorsementService,
                    AvailabilityService: AvailabilityService,
                    FNOLService: FNOLService,
                    ClaimService: ClaimService,
                    ClaimDownloadService: ClaimDocumentService,
                    BillingService: BillingService,
                    EnrollmentService: EnrollmentService,
                    ContactService: ProducerInfoService,
                }}
            >
                <ErrorBoundary onError={handleError}>
                    <ViewModelServiceContext.Provider value={viewModelService}>
                        <ModalNextProvider />
                        <ApplicationPropertyWithContextProvider>
                            <Switch>
                                <Route exact path="/login-page" component={EntryPage} />
                                <Route exact path="/auth/resetpassword" component={ResetPasswordPage} />
                                <Route exact path="/signup-enrollment" component={SignUpEnrollment} />
                                <Route path="/oauth_error" component={AccessDeniedLandingPage} />
                                <Route path="/uaa/oauth_error" component={AccessDeniedLandingPage} />
                                <Route exact path="/access-denied" component={AccessDenied} />
                                <Route exact path="/app-error" component={AppError} />
                                <DynamicRoute path="/">
                                    <GrantedAuthorities
                                        checkRenderBasedOnAuthorities={shouldRouteToSignUp}
                                    >
                                        <PageHeaderComponent
                                            routes={filterNotAvailableRoutes(navRoutes)}
                                        />
                                        <Main>
                                            <NavRoutes
                                                resolveComponentMap={dynamicComponentMap}
                                                routes={routesWithoutTitle(navRoutes)}
                                            />
                                            <FooterComponent id="tdicFooter" />
                                        </Main>
                                    </GrantedAuthorities>
                                </DynamicRoute>
                            </Switch>
                        </ApplicationPropertyWithContextProvider>
                    </ViewModelServiceContext.Provider>
                </ErrorBoundary>
            </DependencyProvider>
        </AccurateBreakpointPropagation>
    );
}

export default withAuthContextProvider()(App);
